import React from 'react';
import I18n from 'i18n-js';
import ShopBadges from '@reverbdotcom/commons/dist/components/shop_badges';
import StarRating from '@reverbdotcom/commons/dist/components/star_rating';
import UrlHelpers from '../shared/url_helpers';

interface IProps {
  avatarUrl: string;
  slug: string;
  shopName: string;
  sellerFeedbacksCount: number;
  sellerRating: number;
  preferredSeller: boolean;
  quickShipper: boolean;
  quickResponder: boolean;
  createdAt: string;
  location: string;
}

export default function ListingShopModule(props: IProps) {
  const renderAchievements = () => {
    if (!props.preferredSeller && !props.quickResponder && !props.quickShipper) { return; }
    return (
      <div>
        <p className="listing-shop-module__achievements">
          {I18n.t('discovery.shop.listingModule.sellerAchievements')}
        </p>
        <div className="d-flex fx-justify-center">
          <ShopBadges
            preferredSeller={props.preferredSeller}
            quickResponder={props.quickResponder}
            quickShipper={props.quickShipper}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="listing-shop-module">
      <div className="listing-shop-module__avatar">
        <a href={UrlHelpers.shopPath(props.slug)}>
          <img src={props.avatarUrl} alt="" />
        </a>
      </div>
      <a
        className="listing-shop-module__shop-name"
        href={UrlHelpers.shopPath(props.slug)}
      >
        {props.shopName}
      </a>
      <a href={UrlHelpers.shopFeedbackPath(props.slug)}>
        <StarRating
          rating={props.sellerRating / 5}
          count={props.sellerFeedbacksCount}
        />
      </a>
      <p className="listing-shop-module__location">
        {props.location}
      </p>
      <p className="listing-shop-module__joined">
        {I18n.t('discovery.shop.listingModule.joined', { date: props.createdAt })}
      </p>
      {renderAchievements()}
    </div>
  );
}
